import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const sandboxRelayJiraPageRoute: InvariantJiraRoute = {
	name: 'sandbox-relay-defer-jira',
	path: '/jira/software/sandbox/relay/jirasearch',
	exact: true,
};
